import { create } from "zustand"

export interface LogEntry {
  timestamp: string
  level: "info" | "warn" | "error" | "debug"
  source: string
  message: string
  data?: unknown
}

interface LoggerStore {
  logs: LogEntry[]
  maxLogs: number
  addLog: (entry: Omit<LogEntry, "timestamp">) => void
  clearLogs: () => void
  exportLogs: () => string
  getLogs: () => LogEntry[]
}

export const useLoggerStore = create<LoggerStore>((set, get) => ({
  logs: [],
  maxLogs: 500,

  addLog: (entry) =>
    set((state) => ({
      logs: [
        {
          timestamp: new Date().toISOString(),
          ...entry,
        },
        ...state.logs,
      ].slice(0, state.maxLogs),
    })),

  clearLogs: () => set({ logs: [] }),

  exportLogs: () => {
    const logs = get().logs
    return JSON.stringify(
      {
        exported: new Date().toISOString(),
        appVersion: "1.0.0",
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "N/A",
        logs,
      },
      null,
      2,
    )
  },

  getLogs: () => get().logs,
}))
